"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jfdSmt = void 0;
const jfd_1 = require("@le2/jfd");
exports.jfdSmt = {
    fields: {
        NCICDesignationCode: Object.assign(Object.assign({}, jfd_1.type10Fields.NCICDesignationCode), { 
            // KC doesn't adhere to the standard, in particular, there are some
            // EBTS/NST files that have more than 3 occurrences for this field
            maxOccurrences: 4 }),
        SMT: Object.assign(Object.assign({}, jfd_1.ncicCodeFields.SMT), { maxOccurrences: 4 }),
        SMTDescriptors: Object.assign({}, jfd_1.type10Fields.SMTDescriptors)
    },
    rules: [jfd_1.smtLocationToNcicCode],
    onImport: [jfd_1.ncicCodeToTypeAndLocation]
};
//# sourceMappingURL=jfd-smt-kcso.js.map